import React from 'react';
import {
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Divider,
    Button,
    ListItemText,
    Checkbox,
    Chip,
    InputAdornment,
    IconButton
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import './selectInput.scss';

export const SelectInput = ({
    options = [],
    label = '',
    onOptionCreation,
    onChange,
    value,
    disabled,
    name,
    multiple,
    margin = 'none',
    required,
    checkMarks = false,
    chipValue = false,
    emptyOption = false,
    fullWidth = true,
    onClearValue,
    ...props
}) => {

    const renderValue = (selected) => {
        if (multiple && chipValue) {
            return (
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {selected.map((value) => (
                        <Chip key={value} label={options.find(option => option.id === value)?.displayName} sx={{ mr: '4px' }} />
                    ))}
                </div>
            );
        } else if (multiple) {
            return selected.map((value) => options.find(option => option.id === value)?.displayName).join(', ');
        } else {
            return options.find(option => option.id === selected)?.displayName;
        }
    };

    return (
        <FormControl
            fullWidth={fullWidth}
            variant='outlined'
            size='small'
            margin={margin}
            required={required}
            disabled={disabled}
        >
            <InputLabel>{label}</InputLabel>
            <Select
                {...props}
                fullWidth
                variant='outlined'
                size='small'
                label={label}
                className='select-type-input'
                onChange={onChange}
                multiple={multiple}
                value={value !== undefined ? value : (multiple ? [] : '')}
                name={name}
                renderValue={renderValue}
                endAdornment={
                    onClearValue && (
                        <InputAdornment sx={{ marginRight: "10px" }} position="end">
                            <IconButton onClick={() => { onClearValue(); }}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }
            >
                {
                    (emptyOption) &&
                    <MenuItem key={0} value={0}>
                        &nbsp;
                    </MenuItem>
                }

                {!checkMarks && options?.map(({ id, displayName, disabled }, index) => (
                    <MenuItem
                        key={`${index}${displayName}`}
                        className='select-input-menu-item'
                        value={id}
                        dense
                        disabled={disabled}
                    >
                        {displayName}
                    </MenuItem>
                ))}
                {checkMarks && options?.map(({ id, displayName, disabled }, index) => (
                    <MenuItem
                        key={`${index}${displayName}`}
                        className='select-input-menu-item'
                        value={id}
                        dense
                        disabled={disabled}
                    >
                        <Checkbox key={`${value}${id}`} checked={value && value.includes(id)} />
                        <ListItemText primary={displayName} />
                    </MenuItem>
                ))}
                {onOptionCreation && (
                    <>
                        <Divider />
                        <MenuItem className='select-input-menu-item' disableRipple>
                            <Button
                                disableRipple
                                onClick={onOptionCreation}
                                startIcon={<AddCircleIcon />}
                                size='small'
                                variant='outlined'
                            > Agregar
                            </Button>
                        </MenuItem>
                    </>
                )}
            </Select>
        </FormControl>
    )
}